import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  showPopup(title: string, messaje: string, icon: SweetAlertIcon = 'warning', confirmButtonText: string) {
    Swal.fire({
      title,
      text: messaje,
      icon,
      confirmButtonText,
    });
  }

  showAlert(messaje: string, icon: SweetAlertIcon = 'warning', title: string = 'Aviso Importante') {
    Swal.fire({
      title,
      text: messaje,
      icon,
      confirmButtonText: '¡Gracias!',
    });
  }

  showAlertProblem(callback?) {
    Swal.fire({
      title: 'Aviso Importante',
      text:
        'Parece que hay un problema con tu orden. Comunícate con el comercio para mayor información',
      icon: 'warning',
      confirmButtonText: 'Ok',
    }).then(resultSwal => {
      callback ? callback(resultSwal) : false;
    });
  }


  showAlertThreeDs(title?: string, text?: string){
    return Swal.fire({
      title,
      text,
      icon: 'error',
      showCancelButton: false
    })
  }
}
